const prepareForEditing = (
  html: string,
  replaceRegex = /<(q-link|vq-link|cq-link|cvq-link)[^>]*?>.*?<\/\1>/g,
  charBase = 0xf222
): { html: string; charsMap: { [char: string]: { text: string; title?: string } }; charsRegexp: RegExp } => {
  let currentChar = charBase
  const charsMap: { [char: string]: { text: string; title?: string } } = {}
  const usedChars: string[] = []

  const convertedHtml = html.replace(replaceRegex, match => {
    const char = String.fromCodePoint(currentChar)
    const titleMatch = match.match(/title="([^"]*)"/)
    const title = titleMatch ? titleMatch[1] : void 0

    charsMap[char] = { text: match, ...(title && { title }) }
    usedChars.push(char)
    currentChar++
    return char
  })

  const charsRegexp = usedChars.length > 0 ? new RegExp(`[${usedChars.join('')}]`, 'g') : new RegExp('a^')

  return {
    html: convertedHtml,
    charsMap: charsMap,
    charsRegexp
  }
}

const applyEditing = (html: string, charsMap: { [char: string]: { text: string } }, charsRegexp: RegExp): string =>
  html.replace(charsRegexp, char => {
    const replacement = charsMap[char]
    if (!replacement) {
      return char
    }
    return replacement.text
  })

export { prepareForEditing, applyEditing }
